import { ReactElement } from 'react';
import { IFragmentContentfulHostedVideo } from 'types/contentful';

type Props = {
  video: IFragmentContentfulHostedVideo;
};

export default function ContentfulVideo({ video }: Props): ReactElement {
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      className="mx-auto"
      controls
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      preload="auto"
      poster={video.fields.previewImage.fields.file.url}
    >
      <source
        src={video.fields.video.fields.file.url}
        type={video.fields.video.fields.file.contentType}
      ></source>
    </video>
  );
}
